import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  tokenSolver,
  getFromStorage,
  stamps,
  scrollToTop,
  privGtmKey,
  stampsLabel,
  getImg,
  toggleScrollLock,
  getCardDetail,
} from "../utils";
import {
  CoalitionSpinner,
  EmptyBlock,
  CoalitionButton,
  CoalitionCardStamps,
  CoalitionModal,
  CoalitionCardStampsDetail,
  isTokenValid,
} from "./../components";
import { chevron_left, empty_stamps } from "./../pngs";
import {
  sendTag,
  event_properties_102_01,
  event_properties_102_02,
} from "./../components/CoalitionGtm";

export const StampsPage = () => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_102_01());
  }, [gtm]);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [stampsCards, updateStampsCards] = useState([]);

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const setStampsCards = async () => {
      setLoading(true);
      const rawStamps = getFromStorage(stamps);
      await updateStampsCards(rawStamps);
      setLoading(false);
      scrollToTop();
    };
    setStampsCards();
  }, []);

  return loading ? (
    <CoalitionSpinner />
  ) : (
    <div className="specific-page">
      <PagePrebuilt
        stamps={stampsCards}
        buttonClicked={() => navigate(`/?${tokenSolver()}`)}
      />
    </div>
  );
};

const PagePrebuilt = ({ stamps = [], buttonClicked }) => {
  const gtm = localStorage.getItem(privGtmKey);
  const handleClick = (id, label) => {
    toggleModal(id);
    if (gtm) {
      let payload = event_properties_102_02();
      payload.punch_card_id = id;
      payload.punch_card_progress = label;
      payload.click_id = null;
      sendTag(gtm, payload);
    }
  };

  const [modal, setModal] = useState();
  const [shown, setShown] = useState(false);
  const [activeCard, setActiveCard] = useState();

  const toggleModal = (modal = false) => {
    setShown(Boolean(modal));
    toggleScrollLock();
    setActiveCard(getCardDetail(stamps, modal));
  };

  return (
    <>
      {!stamps || stamps.length === 0 ? (
        <>
          <EmptyBlock
            title={"Junta tus sellos"}
            description={
              "Muy pronto podrás llevarte tus productos favoritos de regalo al juntar tus sellos"
            }
            emptyState={empty_stamps}
          >
            <CoalitionButton
              label="Volver al Inicio"
              klass="coalition-button-go-dashboard"
              onClickEvent={buttonClicked}
            />
          </EmptyBlock>
        </>
      ) : (
        <>
          <div className="carousel-cards">
            <>
              <CoalitionButton
                label={"Sellos"}
                klass="nav-button"
                onClickEvent={buttonClicked}
              >
                {getImg(chevron_left, "back-icon")}
              </CoalitionButton>
            </>
            <div className="title">{"Junta tus sellos"}</div>
            <div className="description">
              {"Acumula compras y llévate tus productos favoritos de regalo"}
            </div>
            {stamps.map((i, k) => (
              <CoalitionCardStamps
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                description={i.description}
                used={i.balance}
                needed={i.required_balance}
                availableToRedeem={i.available_to_redeem}
                showModal={() => handleClick(i.id, stampsLabel(i))}
              />
            ))}
          </div>
          {shown ? (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={"Todo sobre tus Sellos"}
            >
              <CoalitionCardStampsDetail card={activeCard} />
            </CoalitionModal>
          ) : null}
        </>
      )}
    </>
  );
};
